module.exports = __webpack_public_path__ + "fonts/0c7c710.woff";